import { render, staticRenderFns } from "./items.vue?vue&type=template&id=483fb9da&scoped=true&"
import script from "./items.vue?vue&type=script&lang=js&"
export * from "./items.vue?vue&type=script&lang=js&"
import style0 from "./items.vue?vue&type=style&index=0&id=483fb9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483fb9da",
  null
  
)

export default component.exports